@if (isLoading()) {
  <div class="person-detail person-detail--skeleton container">
    <div class="person-detail__hero-skeleton">
      <ngx-skeleton-loader
        [theme]="{
          width: '100%',
          height: '88px',
          'border-radius': '8px',
          margin: '0 0 0 0',
        }" />
      <div class="person-detail__hero-skeleton-inner">
        <ngx-skeleton-loader
          [theme]="{
            width: '112px',
            height: '112px',
            'border-radius': '20px',
            position: 'relative',
            top: '-40px',
          }" />
        <div class="person-detail__hero-skeleton-body">
          <ngx-skeleton-loader [theme]="{ height: '28px', width: '55%' }" />
          <ngx-skeleton-loader [theme]="{ height: '16px', width: '35%' }" />
          <ngx-skeleton-loader [theme]="{ height: '56px', width: '100%' }" />
        </div>
      </div>
    </div>
  </div>
} @else {
  @let projectData = project();
  @if (hasContent() && projectData) {
    <article class="person-detail container">
      <nav class="person-detail__breadcrumbs" aria-label="Breadcrumb">
        <a class="person-detail__crumb-link" routerLink="/projects">
          {{ 'global.projects' | translate }}
        </a>
        @if (projectData.title != null && (projectData.title | translateData); as crumbTitle) {
          @if (crumbTitle && crumbTitle !== '-') {
            <span class="person-detail__crumb-sep" aria-hidden="true">&gt;</span>
            <span class="person-detail__crumb-current">{{ crumbTitle }}</span>
          }
        }
      </nav>

      <div class="person-detail__body-grid person-detail__body-grid--with-rail">
        <div class="person-detail__body-grid-hero">
          <header class="person-detail__hero">
            <div class="person-detail__hero-banner" aria-hidden="true"></div>
            <div class="person-detail__hero-inner">
              <div class="person-detail__hero-body">
                <div class="person-detail__hero-heading">
                  <span class="person-detail__type-badge">{{
                    projectStatusKey() | translate
                  }}</span>
                  @if (projectData.code != null) {
                    <span class="person-detail__type-badge">{{
                      'projects.detail.projectCode' | translate
                    }}: #{{ projectData.code }}</span>
                  }
                </div>
                @if (projectData.title != null) {
                  <div class="person-detail__title-row">
                    <h1 class="person-detail__title">
                      {{ projectData.title | translateData }}
                    </h1>
                    @if (canSubmitQuote()) {
                      <div class="projects-detail__quote-actions">
                        <pwj-button
                          class="projects-detail__quote-btn"
                          variant="primary"
                          size="medium"
                          icon="chevron-right"
                          [rotateIconInRtl]="true"
                          [iconReversePosition]="true"
                          type="button"
                          [disabled]="isQuoteAlreadySent()"
                          (click)="openQuoteDialog()">
                          {{ 'projects.quote.submit' | translate }}
                        </pwj-button>
                        @if (isQuoteAlreadySent()) {
                          <span class="projects-detail__quote-sent">
                            {{ 'projects.quote.alreadySent' | translate }}
                          </span>
                        }
                      </div>
                    }
                  </div>
                }
                @if (projectData.category?.title != null) {
                  <p class="person-detail__role">
                    {{ projectData.category!.title | translateData }}
                  </p>
                }
                @if (projectData.created_at != null) {
                  <p class="person-detail__region">
                    <i
                      class="iconsax person-detail__region-icon"
                      icon-name="calendar-1"
                      aria-hidden="true"></i>
                    {{ projectData.created_at | date: 'mediumDate' }}
                  </p>
                }
              </div>
            </div>
          </header>

          @if (
            projectData.description != null &&
              (projectData.description | translateData);
            as desc
          ) {
            @if (desc && desc !== '-') {
              <section class="person-detail__section">
                <h2 class="person-detail__section-title">
                  {{ 'projects.detail.description' | translate }}
                </h2>
                <div class="person-detail__bio">{{ desc }}</div>
              </section>
            }
          }

          @if (projectPhotos().length > 0) {
            <section class="person-detail__section">
              <h2 class="person-detail__section-title">
                {{ 'projects.detail.photos' | translate }}
              </h2>
              <div class="person-detail__installation-photos">
                <pwj-media-photos-grid
                  [photos]="projectPhotos()"
                  imageWidth="240"
                  imageHeight="180" />
              </div>
            </section>
          }

          @if (projectVideos().length > 0) {
            <section class="person-detail__section">
              <h2 class="person-detail__section-title">
                {{ 'projects.detail.videos' | translate }}
              </h2>
              <div class="person-detail__installation-videos">
                <pwj-media-videos-grid [videos]="projectVideos()" />
              </div>
            </section>
          }
        </div>

        <aside class="person-detail__side-rail">
          <div class="person-detail__panel person-detail__contact-panel">
            <h2
              class="person-detail__panel-title"
              id="project-detail-owner-heading">
              {{ 'projects.detail.ownerDetails' | translate }}
            </h2>

            <div
              class="person-detail__contact-row"
              [class.person-detail__locked]="isOwnerLocked()">
              <span class="person-detail__contact-icon-wrap">
                <i class="iconsax" icon-name="user-1" aria-hidden="true"></i>
              </span>
              <div class="person-detail__contact-copy">
                <span class="person-detail__contact-label">{{
                  'projects.detail.firstName' | translate
                }}</span>
                <span class="person-detail__contact-value">{{
                  displayFirstName()
                }}</span>
              </div>
            </div>

            @if (canViewOwnerDetails()) {
              <div
                class="person-detail__contact-row"
                [class.person-detail__locked]="isOwnerLocked()">
                <span class="person-detail__contact-icon-wrap">
                  <i class="iconsax" icon-name="user-1" aria-hidden="true"></i>
                </span>
                <div class="person-detail__contact-copy">
                  <span class="person-detail__contact-label">{{
                    'projects.detail.lastName' | translate
                  }}</span>
                  <span class="person-detail__contact-value">{{
                    displayLastName()
                  }}</span>
                </div>
              </div>
            }

            @if (hasRealOwner() && projectData.owner?.type != null) {
              <div class="person-detail__contact-row">
                <span class="person-detail__contact-icon-wrap">
                  <i class="iconsax" icon-name="briefcase" aria-hidden="true"></i>
                </span>
                <div class="person-detail__contact-copy">
                  <span class="person-detail__contact-label">{{
                    'projects.detail.ownerType' | translate
                  }}</span>
                  <span class="person-detail__contact-value">{{
                    ownerTypeKey() | translate
                  }}</span>
                </div>
              </div>
            } @else if (isOwnerLocked()) {
              <div class="person-detail__contact-row person-detail__locked">
                <span class="person-detail__contact-icon-wrap">
                  <i class="iconsax" icon-name="briefcase" aria-hidden="true"></i>
                </span>
                <div class="person-detail__contact-copy">
                  <span class="person-detail__contact-label">{{
                    'projects.detail.ownerType' | translate
                  }}</span>
                  <span class="person-detail__contact-value">{{
                    'projects.ownerTypes.PROJECT_OWNER' | translate
                  }}</span>
                </div>
              </div>
            }

            @if (hasRealOwner() && projectData.owner?.is_verified === true) {
              <div class="person-detail__contact-row">
                <span class="person-detail__contact-icon-wrap">
                  <i class="iconsax" icon-name="verify" aria-hidden="true"></i>
                </span>
                <div class="person-detail__contact-copy">
                  <span class="person-detail__contact-label">{{
                    'projects.detail.verified' | translate
                  }}</span>
                  <span class="person-detail__contact-value">{{
                    'projects.detail.verifiedYes' | translate
                  }}</span>
                </div>
              </div>
            } @else if (isOwnerLocked()) {
              <div class="person-detail__contact-row person-detail__locked">
                <span class="person-detail__contact-icon-wrap">
                  <i class="iconsax" icon-name="verify" aria-hidden="true"></i>
                </span>
                <div class="person-detail__contact-copy">
                  <span class="person-detail__contact-label">{{
                    'projects.detail.verified' | translate
                  }}</span>
                  <span class="person-detail__contact-value">{{
                    'projects.detail.verifiedYes' | translate
                  }}</span>
                </div>
              </div>
            }
          </div>
        </aside>
      </div>
    </article>
  } @else {
    <div class="container">
      <pwj-no-content message="projects.notFound" />
    </div>
  }
}
